export default "__VITE_ASSET__D_4WTfXu__"